import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebar: {
      open: false,
      drawer: false,
      mini: false,
      expand_on_hover: false,
    },
    config: {
      items_per_page: 10,
    },
    client: {
      pagination: {
        page: 1,
      },
      filter: {
        selected_status: true,
        salesman_selected: null,
        client_type_selected: null,
        client_zone_selected: null,
        search: ""
      }
    },
    supplier: {
      pagination: {
        page: 1,
      },
      filter: {
        selected_status: true,
        supplier_type_selected: null,
        search: ""
      }
    },
    cta_cte_client: {
      pagination: {
        page: 1,
      },
      filter: {
        salesman_selected: null,
        zone_client_selected: null,
        search: ""
      }
    },
    cta_cte_supplier: {
      pagination: {
        page: 1,
      },
      filter: {
        search: ""
      }
    },
    movements_stock: {
      pagination: {
        page: 1,
      },
      filter: {
        desde_selected: new Date().toISOString().substr(0, 10),
        hasta_selected: new Date().toISOString().substr(0, 10),
        warehouse_selected: null,
        product_selected: null,
        search: ""
      }
    },
  },
  mutations: {
    setOpenSidebar: function (state, payload) {
      if (payload.open != undefined) state.sidebar.open = payload.open;

      if (payload.drawer != undefined) state.sidebar.drawer = payload.drawer;

      if (payload.mini != undefined) state.sidebar.mini = payload.mini;
      if (payload.expand_on_hover != undefined) state.sidebar.expand_on_hover = payload.expand_on_hover;
    },
    setCurrentPageClient: function (state, pagination) {
      state.client.pagination.page = pagination;
    },
    setFilterClient: function (state,payload) { 
      if (payload.selected_status != undefined) {
        state.client.filter.selected_status = payload.selected_status;
      } 

      if ('salesman_selected' in payload && payload.salesman_selected !== undefined) {
        state.client.filter.salesman_selected = payload.salesman_selected;
      }

      if ('client_type_selected' in payload && payload.client_type_selected != undefined) {
        state.client.filter.client_type_selected = payload.client_type_selected;
      } 

      if ('client_zone_selected' in payload && payload.client_zone_selected != undefined) { 
        state.client.filter.client_zone_selected = payload.client_zone_selected;
      }
      
      if(payload.search != undefined) state.client.filter.search = payload.search;
    },
    setCurrentPageSupplier: function (state, pagination) {
      state.supplier.pagination.page = pagination;
    },
    setFilterSupplier: function (state,payload) { 
      if (payload.selected_status != undefined) state.supplier.filter.selected_status = payload.selected_status;
      if(payload.search != undefined) state.supplier.filter.search = payload.search;
      if ('supplier_type_selected' in payload && payload.supplier_type_selected != undefined) {
        state.supplier.filter.supplier_type_selected = payload.supplier_type_selected;
      }
    },
    setCurrentPageCtaCteClient: function (state, pagination) {
      state.cta_cte_client.pagination.page = pagination;
    },
    setFilterCtaCteClient: function (state,payload) { 
      if ('salesman_selected' in payload && payload.salesman_selected !== undefined) {
        state.cta_cte_client.filter.salesman_selected = payload.salesman_selected;
      }

      if ('zone_client_selected' in payload && payload.zone_client_selected !== undefined) {
        state.cta_cte_client.filter.zone_client_selected = payload.zone_client_selected;
      }
      if(payload.search != undefined) state.cta_cte_client.filter.search = payload.search;
    },
    setCurrentPageCtaCteSupplier: function (state, pagination) {
      state.cta_cte_supplier.pagination.page = pagination;
    },
    setFilterCtaCteSupplier: function (state,payload) { 
      if(payload.search != undefined) state.cta_cte_supplier.filter.search = payload.search;
    },
    setCurrentPageMovementsStock: function (state, pagination) {
      state.movements_stock.pagination.page = pagination;
    },
    setFilterMovementsStock: function (state, payload) {
      if ('desde_selected' in payload && payload.desde_selected !== undefined) {
        state.movements_stock.filter.desde_selected = payload.desde_selected;
      }
      if ('hasta_selected' in payload && payload.hasta_selected !== undefined) {
        state.movements_stock.filter.hasta_selected = payload.hasta_selected;
      }
      if ('warehouse_selected' in payload && payload.warehouse_selected !== undefined) {
        state.movements_stock.filter.warehouse_selected = payload.warehouse_selected;
      }
      if ('product_selected' in payload && payload.product_selected !== undefined) {
        state.movements_stock.filter.product_selected = payload.product_selected;
      }
      if (payload.search != undefined) {
        state.movements_stock.filter.search = payload.search;
      }
    },
  },
  actions: {},
  modules: {},
});